import { useCallback, useEffect, useMemo, useState } from 'react';
export function useChartSeriesVisibility(seriesKeys, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.mode, mode = _c === void 0 ? 'isolate' : _c;
    var _d = useState(function () { return new Set(); }), hiddenInHideMode = _d[0], setHiddenInHideMode = _d[1];
    var _e = useState(function () { return new Set(); }), selectedInIsolateMode = _e[0], setSelectedInIsolateMode = _e[1];
    var seriesKeysSignature = useMemo(function () { return seriesKeys.join('\0'); }, [seriesKeys]);
    useEffect(function () {
        setHiddenInHideMode(new Set());
        setSelectedInIsolateMode(new Set());
    }, [seriesKeysSignature]);
    var hiddenSeries = useMemo(function () {
        if (mode === 'hide') {
            return hiddenInHideMode;
        }
        if (selectedInIsolateMode.size === 0) {
            return new Set();
        }
        return new Set(seriesKeys.filter(function (seriesKey) { return !selectedInIsolateMode.has(seriesKey); }));
    }, [hiddenInHideMode, mode, selectedInIsolateMode, seriesKeys]);
    var toggleSeries = useCallback(function (key) {
        if (!seriesKeys.includes(key)) {
            return;
        }
        if (mode === 'isolate') {
            setSelectedInIsolateMode(function (prev) {
                if (prev.has(key)) {
                    var next_1 = new Set(prev);
                    next_1.delete(key);
                    return next_1;
                }
                if (prev.size === 0) {
                    return new Set([key]);
                }
                var next = new Set(prev);
                next.add(key);
                if (next.size === seriesKeys.length) {
                    return new Set();
                }
                return next;
            });
            return;
        }
        setHiddenInHideMode(function (prev) {
            if (prev.has(key)) {
                var next_2 = new Set(prev);
                next_2.delete(key);
                return next_2;
            }
            if (seriesKeys.length - prev.size <= 1) {
                return prev;
            }
            var next = new Set(prev);
            next.add(key);
            return next;
        });
    }, [mode, seriesKeys]);
    var isSeriesVisible = useCallback(function (key) { return !hiddenSeries.has(key); }, [hiddenSeries]);
    return { hiddenSeries: hiddenSeries, toggleSeries: toggleSeries, isSeriesVisible: isSeriesVisible };
}
